<template>
  <div class="for-background-color">
    <div class="navigation">
      <ul>
        <li
          class="list"
          v-for="link in links"
          @click="linkclick(link.id)"
          :key="link"
          ref="navList"
        >
          <router-link :to="{ name: link.name }" class="aTag">
            <span class="icon">
              <ion-icon :name="link.iconName"></ion-icon>
            </span>
            <span class="text">{{ link.text }}</span>
          </router-link>
        </li>
        <!-- <li class="list " :ref="listLink" @click="linkclick">
                    <router-link :to="{ name: 'playlist' }" class="aTag">
                        <span class="icon">
                            <ion-icon name="create"></ion-icon>
                        </span>
                        <span class="text">Create</span>
                    </router-link>
                </li>
                <li class="list " :ref="listLink" @click="linkclick">
                    <router-link :to="{ name: 'UserPlaylists' }" class="aTag">
                        <span class="icon">
                            <ion-icon name="list-circle"></ion-icon>
                        </span>
                        <span class="text">My Lists</span>
                    </router-link>
                </li>
                <li class="list " :ref="listLink" @click="linkclick">
                    <router-link :to="{ name: 'Settings' }" class="aTag">
                        <span class="icon">
                            <ion-icon name="settings-outline"></ion-icon>
                        </span>
                        <span class="text">Settings</span>
                    </router-link>
                </li>
                <li class="list" :ref="listLink"  @click="linkclick">
                    <router-link to="#" @click="themeMode" class="aTag">
                        <span class="icon">
                            <ion-icon v-if="darktheme" name="moon-outline"></ion-icon>
                            <ion-icon v-else name="sunny-outline"></ion-icon>
                        </span>
                        <span class="text">Theme</span>
                    </router-link>
                </li> -->
        <div class="indicator"></div>
      </ul>
      <!-- <nav>
                <router-link :to="{ name: 'home' }" v-bind:ref="links">    
                    <span class="icon">
                        <ion-icon name="home-outline"></ion-icon>
                    </span>    
                    Home
                </router-link>
                <router-link :to="{ name: 'UserPlaylists' }">  
                    <span class="icon">
                        <ion-icon name="home-outline"></ion-icon>
                    </span>      
                    My Playlist
                </router-link>
               
                <router-link :to="{ name: 'Settings' }">   
                    <span class="icon">
                        <ion-icon name="home-outline"></ion-icon>
                    </span>     
                    Settings
                </router-link>
            </nav> -->
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import useLogut from "@/composable/useLogout";
import { useRouter } from "vue-router";
import getUser from "@/composable/getUser";

export default {
  setup(props, context) {
    const { error, logout, isPending } = useLogut();
    const listLink = ref(null);

    const { user } = getUser();
    const activeted = ref(true);

    const router = useRouter();

    let darktheme = false;

    const themeMode = () => {
      console.log("Bosildi");
      darktheme = !darktheme;
      console.log(darktheme);
      console.log("Ishladi");
    };

    const handleLogOut = async () => {
      if (confirm("Chiqmoqchimisiz ?")) {
        await logout();
      } else {
        console.log("LogOut Cenceled");
      }
      console.log("Foydalanuvchi Log Out Bo'ldi");
      router.push("/login");
    };

    const navList = ref(null);

    const linkclick = async (elem) => {
      console.log(elem);
      if (elem == navList.value.length - 1) {
        if (confirm("Chiqmoqchimisiz ?")) {
          await logout();
        } else {
          console.log("LogOut Cenceled");
        }
        console.log("Foydalanuvchi Log Out Bo'ldi");
        router.push("/login");
      }
      navList.value.filter(async (el, index) => {
        el.classList.remove("active");
        console.log(navList.value.length - 1);
        if (index == elem) {
          el.classList.add("active");
        }
      });
    };

    const links = ref([
      {
        id: 0,
        name: "home",
        iconName: "home-outline",
        text: "Home",
      },
      {
        id: 1,
        name: "UserPlaylists",
        iconName: "list-circle",
        text: "My Playlists",
      },
      {
        id: 2,
        name: "playlist",
        iconName: "create",
        text: "Create PlayList",
      },
      {
        id: 3,
        name: "Settings",
        iconName: "settings-outline",
        text: "Settings",
      },
      {
        id: 4,
        iconName: "exit",
        text: "LogOut",
        func: "handleLogOut",
      },
    ]);

    onMounted(() => {
      console.log(navList.value);
      navList.value[0].classList.add("active");
      navList.value[navList.value.length - 1];
    });

    return {
      handleLogOut,
      themeMode,
      darktheme,
      user,
      linkclick,
      listLink,
      links,
      navList,
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

:root {
  --clr: #222327;
  --primary: #4f515a;
  --secondary: #ebebeb;
  --warning: #da0f41;
}

.for-background-color {
  display: none;
  justify-content: center;
  max-height: 150px;
  background-color: rgba(255, 255, 255, 0.444);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 1s;
  z-index: 999;
}

.navigation {
  width: 440px;
  height: 70px;
  background: #fff;
  background-color: #222327;

  /* position: relative; */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;

  top: 450px;
}

.navigation ul {
  display: flex;
  width: 350px;
}

.navigation ul li {
  position: relative;
  list-style: none;
  width: 70px;
  height: 70px;
  z-index: 1;
  margin: 5px;
}

.navigation ul li .aTag {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  text-align: center;
  font-weight: 500;
}

.navigation ul li .aTag .icon,
.navigation ul li a .icon {
  position: relative;
  display: block;
  line-height: 75px;
  font-size: 2em;
  text-align: center;
  transition: 0.5s;
  color: var(--clr);
}

.navigation ul li.active a .icon {
  transform: translateY(-32px);
}

.navigation ul li .aTag .text,
.navigation ul li a .text {
  position: absolute;
  color: var(--clr);
  font-weight: 400;
  font-size: 0.75em;
  letter-spacing: 0.05em;
  transition: 0.5s;
  opacity: 0;
  transform: translateY(20px);
}

.navigation ul li.active .aTag .text {
  opacity: 1;
  transform: translateY(10px);
}

.indicator {
  position: absolute;
  top: -50%;
  width: 70px;
  height: 70px;
  background: #29fd53;
  border-radius: 50%;
  border: 6px solid transparent;
  transition: 0.5s;
}

.indicator::before {
  content: "";
  position: absolute;
  top: 50%;
  left: -22px;
  width: 20px;
  height: 20px;
  background: transparent;
  border-top-right-radius: 20px;
  box-shadow: 1px -10px 0 0 var(--clr);
}

.indicator::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -22px;
  width: 20px;
  height: 20px;
  background: transparent;
  border-top-left-radius: 20px;
  box-shadow: -1px -10px 0 0 var(--clr);
}

.navigation ul li:nth-child(1).active ~ .indicator {
  transform: translateX(calc(70px * 0));
}

.navigation ul li:nth-child(2).active ~ .indicator {
  transform: translateX(calc(70px * 1));
}

.navigation ul li:nth-child(3).active ~ .indicator {
  transform: translateX(calc(70px * 2));
}

.navigation ul li:nth-child(4).active ~ .indicator {
  transform: translateX(calc(70px * 3));
}

.navigation ul li:nth-child(5).active ~ .indicator {
  transform: translateX(calc(70px * 4));
}

@media screen and (max-width: 825px) {
  .for-background-color {
    display: flex;
    transition: 1s;
  }
}

nav {
  padding: 30px 0;
  display: flex;
  justify-content: space-between;
}

nav a {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  color: #2c3e50;
  padding: 15px;
  border-radius: 50%;
  padding-top: 30px;
  width: 90px;
  height: 90px;
}

nav a.router-link-exact-active {
  background-color: #42b983;
}
</style>